import { render, staticRenderFns } from "./ItemListOpenMarketLayout.vue?vue&type=template&id=c2709726&scoped=true"
import script from "./ItemListOpenMarketLayout.vue?vue&type=script&lang=js"
export * from "./ItemListOpenMarketLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2709726",
  null
  
)

export default component.exports